/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { reduxConnect } from '../../common';
import { translate } from '../../common/translation/translate';
import { IStoreState } from '../common/interfaces/types';
import { LifePageSubNavLinkItem } from './LifePageSubNavLinkItem';
import { LifePageIds, LifePageRoutePaths } from './lifePageTypes';

interface LifeSubNavLinkItemsProps {
    activePageId: string;
    isOutdoorSportsEnabled: boolean;
    Latitude: number;
    Longitude: number;
    SlugName: string;
    enableLifePollenPageOnWeb2: boolean;
    enableLifeColdFluPageOnWeb2?: boolean;
}

const snowSkiPageDefualtMapZoom = 6.2;

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { enableLifePollenPageOnWeb2, enableLifeColdFluPageOnWeb2, isOutdoorSportsEnabled, pageId, user } = storeState?.appState?.appState || {};
    const { ActiveLocation } = user || {};
    const { Latitude, Longitude, SlugName } = ActiveLocation?.Locality || {};

    return {
        enableLifePollenPageOnWeb2,
        enableLifeColdFluPageOnWeb2,
        activePageId: pageId,
        isOutdoorSportsEnabled,
        Latitude,
        Longitude,
        SlugName
    };
};

const mapDispatchToProps = {};

export const LifeSubNavLinkItems = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({
    activePageId,
    isOutdoorSportsEnabled,
    Latitude,
    Longitude,
    SlugName,
    enableLifePollenPageOnWeb2,
    enableLifeColdFluPageOnWeb2
}: LifeSubNavLinkItemsProps) => {
    if (activePageId?.toLocaleLowerCase() === LifePageIds.snowSkiDetail) {
        return null;
    }

    return (
        <> 
            {enableLifePollenPageOnWeb2
                ? <LifePageSubNavLinkItem
                    enableLifePollenPageOnWeb2={true}
                    enableLifeColdFluPageOnWeb2={false}
                    linkName={translate('allergiesAndPollen')}
                    linkUrl={`${LifePageRoutePaths.pollen}${SlugName}`}
                    isActive={activePageId?.toLocaleLowerCase() === LifePageIds.pollen}
                /> 
                : <LifePageSubNavLinkItem
                    enableLifePollenPageOnWeb2={false}
                    enableLifeColdFluPageOnWeb2={false}
                    linkName={translate('allergiesAndPollen')}
                    linkUrl={`${LifePageRoutePaths.pollen}${SlugName}`}
                    isActive={activePageId?.toLocaleLowerCase() === LifePageIds.pollen}
                />
            
            }   
            {enableLifeColdFluPageOnWeb2
            ? <LifePageSubNavLinkItem
                enableLifePollenPageOnWeb2={false}
                enableLifeColdFluPageOnWeb2={true}
                linkName={translate('coldFlu')}
                linkUrl={`${LifePageRoutePaths.coldFlu}${SlugName}`}
                isActive={activePageId?.toLocaleLowerCase() === LifePageIds.coldFlu}
            />
            : <LifePageSubNavLinkItem
                enableLifePollenPageOnWeb2={false}
                enableLifeColdFluPageOnWeb2={false}
                linkName={translate('coldFlu')}
                linkUrl={`${LifePageRoutePaths.coldFlu}${SlugName}`}
                isActive={activePageId?.toLocaleLowerCase() === LifePageIds.coldFlu}
            />
            }
            {isOutdoorSportsEnabled && <LifePageSubNavLinkItem
                enableLifePollenPageOnWeb2={false}
                enableLifeColdFluPageOnWeb2={false}
                linkName={translate('outdoorSports')}
                linkUrl={`${LifePageRoutePaths.outdoorSports}${SlugName}`}
                isActive={activePageId?.toLocaleLowerCase() === LifePageIds.outdoorSports}
            />}
            <LifePageSubNavLinkItem
                enableLifePollenPageOnWeb2={false}
                enableLifeColdFluPageOnWeb2={false}
                linkName={translate('snowSki')}
                linkUrl={`${LifePageRoutePaths.snowSki}?center=${Latitude},${Longitude},${snowSkiPageDefualtMapZoom}`}
                isActive={activePageId?.toLocaleLowerCase() === LifePageIds.snowSki}
            />
            <LifePageSubNavLinkItem
                enableLifePollenPageOnWeb2={false}
                enableLifeColdFluPageOnWeb2={false}
                linkName={translate('travel')}
                linkUrl={`${LifePageRoutePaths.travel}${SlugName}`}
                isActive={activePageId?.toLocaleLowerCase() === LifePageIds.travel}
            />
        </>
    );
}));

LifeSubNavLinkItems.displayName = 'LifeSubNavLinkItems';